import { atom } from 'jotai';

export const eventsAtom = atom([]);